// @flow @jsx h
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
import { Component, h } from 'preact'

/* styles */
import styles from './index.css'

type Props = {
  playing: boolean,
  id: string,
  autoplay: string
}

export class LudoElement extends Component<Props> {
  videoElm: HTMLVideoElement
  ludoPlayer: any

  componentDidMount () {
    this.ludoPlayer = require('../../../../../lib/wrappers/ludoWrapper').getLudo().then(ludo => {
      return ludo(this.videoElm, this.props.id, {
        analytics: {
          ga: {
            trackingId: 'UA-3413696-1'
          }
        },
        mute: true
      })
    })
  }

  play () {
    this.ludoPlayer.then(player => {
      player.play()
    })
  }

  pause () {
    this.ludoPlayer.then(player => {
      player.pause()
    })
  }

  componentDidUpdate (previousProps: Props) {
    const { autoplay = 'true' } = this.props

    if (autoplay === 'true' && this.props.playing && !previousProps.playing) {
      this.play()
    } else if (!this.props.playing && previousProps.playing) {
      this.pause()
    }
  }

  render () {
    return <div class={styles.ludoElement}>
      <div class={styles.ludoElement__video} ref={elm => (this.videoElm = elm)} />
    </div>
  }
}
